export const CHAT_INIT_SESSION_KEY = "CHAT_INIT_SESSION_USER";

export const ABLY_CHAT_SETTINGS = {
  GLOBAL_PRESENCE_CHANNEL: "global-presence",
  SUPERSEDED: "superseded",
  ATTACH_REQUEST_SUPERSEDED: "Attach request superseded",
  DETACH_REQUEST_SUPERSEDED: "Detach request superseded",
  CHANNEL_DETACHED: "Channel detached",
  CHANNEL_STATE: {
    INITIALIZED: "initialized",
    DETACHED: "detached",
    FAILED: "failed",
    ATTACHING: "attaching",
    ATTACHED: "attached",
    DETACHING: "detaching",
  },
};

export const CONNECTION_EVENTS = {
  ATTACHED: "attached",
  FAILED: "failed",
  DETACHED: "detached",
  CONNECTED: "connected",
};

export const CHAT_EVENTS = {
  ENTER: "enter",
  LEAVE: "leave",
  NOTIFICATION: "notification",
  NOTIFICATIONS: "notifications",
  MESSAGE: "message",
  MESSAGE_REACTION: "message-reaction",
  ROOM_REACTION: "room-reaction",
  TYPING: "typing",
  ONLINE: "online",
  GLOBAL_PRESENCE: "global-presence",
  VISIBILITY_CHANGE: "visibilitychange",
  FOCUS: "focus",
  VISIBLE: "visible",
  SEND_MESSAGE: "Send message",
};

export const CHAT_USER_EVENT_TYPES = {
  NEW_CHAT: "NEW_CHAT",
  NEW_MESSAGE_ALERT: "NEW_MESSAGE_ALERT",
  CHAT_MESSAGE: "CHAT_MESSAGE",
} as const;

export const CHAT_TEXT_CONSTANTS = {
  SELECT_A_CONVERSATION_TO_VIEW_MESSAGES:
    "Select a conversation to view messages",
  DEFAULT_CHAT_USER_NAME: "User",
  DEACTIVATED_USER_NAME: "Deactivated User",
  DEACTIVATED_USER_BANNER: "This account is no longer available",
  IS_TYPING: "is typing…",
  NEW_MESSAGE: "New message",
};

export const QUICK_REACTION_EMOJIS = ["👍", "❤️", "😂", "😮", "🙏"];

export const CHAT_ERROR_CONSTANTS = {
  BLOCK_REPORT_RELATIONSHIP: "block/report",
} as const;
